import io from 'socket.io-client'
import protocol from '@accelerator/common/protocol.js'

// TODO cache protocol, messes up type hints
export function connect(uri) {
    const socket = io(uri, { path: "/ws/", transports: ['websocket'] })
    return protocol(socket)
}
